import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // block title translation for slash menu
  blocktitle: {
    id: 'Searchkit',
    defaultMessage: 'Searchkit',
  },
  searchBlock: {
    id: 'Search block',
    defaultMessage: 'Search block',
  },
  search: {
    id: 'search',
    defaultMessage: 'search',
  },
  facets: {
    id: 'Facets',
    defaultMessage: 'Facets',
  },
  facet: {
    id: 'Facet',
    defaultMessage: 'Facet',
  },
  label: {
    id: 'Label',
    defaultMessage: 'Label',
  },
  field: {
    id: 'Field',
    defaultMessage: 'Field',
  },
  multipleChoices: {
    id: 'Multiple choices?',
    defaultMessage: 'Multiple choices?',
  },
  facetWidget: {
    id: 'Facet widget',
    defaultMessage: 'Facet widget',
  },
  metadata: {
    id: 'Meta data',
    defaultMessage: 'Meta data',
  },
  searchresult: {
    id: 'Search result',
    defaultMessage: 'Search result',
  },
  searchresults: {
    id: 'Search results',
    defaultMessage: 'Search results',
  },
  // highlights
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  tags: {
    id: 'Tags',
    defaultMessage: 'Tags',
  },
  content: {
    id: 'Content',
    defaultMessage: 'Content',
  },
});

export default messages;
